export default {
  sm: `
  오늘의 가치가 담긴 우리의 데이터는
  우리 기술로 지켜내야 할
  미래의 자산입니다.
  `,
  md: `
  오늘의 가치가 담긴 우리의 데이터는
  우리 기술로 지켜내야 할 미래의 자산입니다.
  `
};
